import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { SubscriptionV2 } from '../../../../types/firm';
import { formatDate } from '../../../../utilities/formatting';

type CancelAlertProps = {
    subscription: SubscriptionV2;
};

function CancelAlert({ subscription }: CancelAlertProps): JSX.Element | null {
    if (!subscription.cancelAt || subscription.status === 'CANCELED') {
        return null;
    }
    return (
        <div className="rounded-md border border-red-400 bg-red-50 w-full p-4 mb-4 flex items-center gap-2">
            <ExclamationCircleIcon className="text-red-600 h-5 w-5 stroke-2" />
            <p className="text-sm font-bold text-contentPrimary flex items-center gap-1">
                Your subscription is set to cancel on <b>{formatDate(subscription.cancelAt)}.</b> If you wish to stop this, please contact
                support.
            </p>
        </div>
    );
}

export default CancelAlert;
